export enum Route {
    DownloadDocument = "documents/download",
    SendDocumentsDownloadLink = "documents/send",
    GetDownloadLimit = "documents/download-limit"
}
